import React, { useState, useEffect, Suspense, useContext, useMemo } from "react";
import "./style/login_style.css";
import { Box, Button, Grid, FormControlLabel, Checkbox } from "@mui/material";
import Captcha from "./Captcha/Captcha";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ReactComponent as Logo } from "../../asset/imgs/MainBackGround/logo.svg";
import { useLoginReq, useRememberLoginReq, useClearRememberReq } from "./Hooks/index";
import InputLogin from "./Inputs/InputLogin";
import Pass from "../../asset/imgs/login/Pass";
import UserLog from "../../asset/imgs/login/UserLog";
//import AuthContext from "../../Context/AuthProvider";
import ToastCustomise from "../../General/Components/ToastCustomise/ToastCustomise";
import { useSelector, useDispatch } from "react-redux";
import { setUpdateLogInCountR } from "../../General/Store/GeneralSlice";
import LoginLoading from "./components/LoginLoading";
import useToast from "../../utils/ToastHook";
import NoticeLogin from "./NoticeLogin";

const LazyLoginNumber = React.lazy(() => import("./LoginNumber"));
const LazyVerificationCode = React.lazy(() => import("./VerificationCode"));

const PASSWORD_MASK = "••••••";

const Login = () => {
  const captcha = useSelector((state) => state?.general?.captcha);
  const dispatch = useDispatch();
  const updateLogInCount = useSelector((state) => state.general.updateLogInCount);
const [forgetPass, setForgetPass] = useState(false);

const [phoneNumber, setPhoneNumber] = useState(null);

const [mustChangePassword, setMustChangePassword] = useState(false); 
const [collectionId, setCollectionId] = useState(null);
 const [verification, setVerification] = useState(false);
 const [timeLeft, setTimeLeft] = useState(120);
  const { colorToast, handleFailed, handleSuccess, openToast, toastText, closeToast } = useToast({
    afterClose: () => {},
  });

  //useContext(AuthContext); 
useEffect(() => {
  if (!verification) return; // فقط وقتی صفحه OTP نمایشه تایمر اجرا بشه
  if (timeLeft <= 0) return;
  const timer = setTimeout(() => setTimeLeft((t) => t - 1), 1000);
  return () => clearTimeout(timer);
}, [timeLeft, verification]);
  const { mutateAsync: loginRequest, isLoading: isLogining } = useLoginReq(
      
    handleSuccess,
   handleFailed,
  (collectionId) => {          
    
    setCollectionId(collectionId);
    setMustChangePassword(true);
    setForgetPass(true);
  }
  
  );
 const { mutateAsync: rememberLoginRequest, isLoading: isRemembering } = useRememberLoginReq(
  handleSuccess,
  handleFailed,
  (collectionId) => {
    console.log("بخش داخلی",collectionId);
    setCollectionId(collectionId);
    setMustChangePassword(true);
    setForgetPass(true);

    // uncheck رمز به خاطر بسپار و پاک کردن توکن
    localStorage.removeItem("rememberMe");
    localStorage.removeItem("rememberedUsername");
    //localStorage.removeItem("hasRefreshToken");

    setInitialValues((prev) => ({
      username: prev.username,
      password: "",
      rememberMe: false,
    }));

    clearRememberRequest();
  }
);

  const { mutateAsync: clearRememberRequest } = useClearRememberReq(handleSuccess, handleFailed);

  const [initialValues, setInitialValues] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });

  const validationSchema = useMemo(
    () =>
      Yup.object({
        username: Yup.string().when("rememberMe", {
          is: true,
          then: (schema) => schema.notRequired(),
          otherwise: (schema) => schema.required("نام کاربری اجباری می باشد"),
        }),
        password: Yup.string().when("rememberMe", {
          is: true,
          then: (schema) => schema.notRequired(),
          otherwise: (schema) => schema.required("پسورد اجباری می باشد"),
        }),
        rememberMe: Yup.boolean(),
      }),
    []
  );

 const onsubmit = async (values, { setSubmitting , resetForm}) => {

  try {
    const isRemember = !!values.rememberMe;
    const isMasked = values.password === PASSWORD_MASK;
    const hasRefresh = localStorage.getItem("rememberMe") === "true";

    

    // remember-login فقط وقتی فلگ داریم
    if (isRemember && (isMasked || !values.password)) {
  if (!hasRefresh) {
    localStorage.removeItem("rememberMe");
    localStorage.removeItem("rememberedUsername");
   // localStorage.removeItem("hasRefreshToken");
    const newValues = { username: values.username, password: "", rememberMe: false };
    setInitialValues(newValues);
    resetForm({ values: newValues });
    handleFailed("توکن معتبر نیست، لطفاً رمز عبور را وارد کنید");
    return;
  }

  try {
    await rememberLoginRequest();
  } catch (err) {
    localStorage.removeItem("rememberMe");
    localStorage.removeItem("rememberedUsername");
   // localStorage.removeItem("hasRefreshToken");
    const newValues = { username: values.username, password: "", rememberMe: false };
    setInitialValues(newValues);
    resetForm({ values: newValues });
        return;
  }
  return;
}


    const payload = {
      username: values.username,
      password: values.password,
      rememberMe: isRemember,
      ...(updateLogInCount ? { updateLogInCount } : {}),
    };

    const result = await loginRequest(payload);
    if (result?.mustChangePassword) {
  setMustChangePassword(true);
  setForgetPass(true);
  return;
}
    dispatch(setUpdateLogInCountR(false));

    if (isRemember) {
      localStorage.setItem("rememberMe", "true");
      localStorage.setItem("rememberedUsername", values.username || "");
     // localStorage.setItem("hasRefreshToken", "true");
    } else {
      const hadRefresh = localStorage.getItem("rememberMe") === "true";
      localStorage.removeItem("rememberMe");
      localStorage.removeItem("rememberedUsername");
     // localStorage.removeItem("hasRefreshToken");

      if (hadRefresh) await clearRememberRequest();
    }
  } catch (e) {
   
  } finally {
    setSubmitting(false);
  }
};


  
 


  const verificationHandler = () => {
    setVerification(false);
  setForgetPass(true);
  setTimeLeft(120);
  };

  const editPhoneNumber = () => {
    setVerification(false);
    setForgetPass(true);
  };

  useEffect(() => {
    const localRemember = localStorage.getItem("rememberMe") === "true";
    const savedUser = localStorage.getItem("rememberedUsername") || "";

    if (localRemember) {
      setInitialValues({
        username: savedUser,
        password: PASSWORD_MASK,
        rememberMe: true,
      });
    } else {
      setInitialValues({
        username: "",
        password: "",
        rememberMe: false,
      });
    }
  }, []);

 const showLoading = isLogining || isRemembering;

  return (
    <>
      <Box display="flex" bgcolor={"#fff"} className="login-box" position="relative">
        {showLoading && (
      <div className="login-loading-overlay">
        <LoginLoading />
      </div>
    )}
        <div className="wrap-box">
          <div className="form-box">
            <div className="login-glass">
              <div className="title">
                <Logo className="logo-login" />
                <h1>فلکسوگرافی رسام نقش آناهیتا</h1>
              </div>

              <div className="form-container">
                {forgetPass ? (
                  <Suspense fallback={<div>Loading...</div>}>
                  <LazyLoginNumber
  forgetPass={forgetPass}
  setForgetPass={setForgetPass}
  collectionId={collectionId}
  classcustom="showLogin"
  onOtpSent={({  phoneNumber: phone }) => {
    if (phone) setPhoneNumber(phone);
    setForgetPass(false);
    setVerification(true);
     setTimeLeft(120);
  }}
/>
                  </Suspense>
                ) : verification ? (
                  <Suspense fallback={<div>Loading...</div>}>
                    <LazyVerificationCode
                      initialValues={initialValues}
                      verificationHandler={verificationHandler}
                      collectionId={collectionId}
                      timeLeft={timeLeft}
                            
                       phoneNumber={phoneNumber}         
                      editPhoneNumber={editPhoneNumber}
                      class="showverifcation"
                      onPasswordChanged={() => {
    handleSuccess("رمز عبور با موفقیت تغییر یافت");
    setVerification(false);
    setForgetPass(false);
   
    setPhoneNumber(null);
    setCollectionId(null);
    setMustChangePassword(false);
  }}
  onBackToLogin={() => {
    setVerification(false);
    setForgetPass(false);
  }}
                    />
                  </Suspense>
                ) : (
                  <div className="bg-withe">
                    <Grid display="flex" alignItems="center" marginBottom={"1rem"}></Grid>

                    {!captcha ? (
                      <Formik
                        enableReinitialize
                       // keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onsubmit}
                      >
                        {({ values, isValid, setFieldValue, errors, touched }) => (
                          <Form>
                            <Box
                              display="flex"
                              flexDirection="column"
                              justifyContent="center"
                              alignItems="center"
                              width={"80%"}
                              margin={"auto"}
                            >
                              <InputLogin
                                classcustom={errors.username && touched.username ? "not-valid" : ""}
                                type="text"
                                lable="نام کاربری"
                                name={"username"}
                                 tooltip = {"توکن معتبر وجود دارد برای تغییر نام کاربری، تیک «مرا به خاطر بسپار» را بردارید"}

                                disabled={values.rememberMe && values.password === PASSWORD_MASK}
                                value={values.username}
                                onchange={(e) => setFieldValue("username", e.target.value)}
                                lableIcon={<UserLog color={"#424242"} />}
                              />
                              {!values.rememberMe && errors.username && touched.username && (
                                <Box sx={{ color: "error.main", fontSize: "10px", width: "100%" }}>
                                  {errors.username}
                                </Box>
                              )}

                             <InputLogin
                                 classcustom={errors.password && touched.password ? "not-valid" : ""}
                                 type="password"
                                 name="password"
                                 tooltip = {"توکن معتبر وجود دارد برای تغییر رمز، تیک «مرا به خاطر بسپار» را بردارید"}
                                 lable="پسورد "
                                 disabled={values.rememberMe && values.password === PASSWORD_MASK}
                                 maskValue={PASSWORD_MASK}
                                 onchange={(e) => setFieldValue("password", e.target.value)}
                                 value={values.password}
                                 lableIcon={<Pass color={"#424242"} />}
                                />
                              {!values.rememberMe && errors.password && touched.password && (
                                <Box sx={{ color: "error.main", fontSize: "10px", width: "100%" }}>
                                  {errors.password}
                                </Box>
                              )}

                              <FormControlLabel
                                control={
                                  <Checkbox
                                    sx={{
                                      color: "rgba(0, 0, 0, 0.87)",
                                      "&.Mui-checked": { color: "rgba(30, 106, 253, 1)" },
                                    }}
                                    checked={values.rememberMe}
                                    onChange={async (e) => {
                                      const next = e.target.checked;
                                      setFieldValue("rememberMe", next);
                                       const hasRefresh = localStorage.getItem("rememberMe") === "true";
                                      if (!next) {
                                        localStorage.removeItem("rememberMe");
                                        localStorage.removeItem("rememberedUsername");
                                        // localStorage.removeItem("hasRefreshToken");
                                       // setFieldValue("username", "");
                                        setFieldValue("password", "");
                                       if (hasRefresh) {
                                        await clearRememberRequest();
                                         }
                                      } else {
                                        localStorage.setItem("rememberMe", "true");
                                        if (values.username) {
                                          localStorage.setItem("rememberedUsername", values.username);
                                        }
                                      }
                                    }}
                                  />
                                }
                                label="مرا به خاطر بسپار"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: "rgba(0, 0, 0, 0.87)",
                                    fontSize: "12px",
                                  },
                                  width: "100%",
                                }}
                              />

                              <Button
                                disabled={!values.rememberMe && !isValid}
                                className="form-btn"
                                type="submit"
                                color="warning"
                                variant="contained"
                                sx={{ width: "80% !important", margin: "auto" }}
                              >
                                ورود
                              </Button>
                            </Box>
                          </Form>
                        )}
                      </Formik>
                    ) : (
                      <Captcha handleFailed={handleFailed} />
                    )}
                  </div>
                )}
              </div>

              <p className="footer-text">تولید کننده انواع کلیشه های ژلاتینی (دیجیتال)</p>
            </div>
          </div>
          <NoticeLogin />
        </div>
      </Box>

      {openToast && (
        <ToastCustomise
          openToast={openToast}
          text={toastText}
          closeing={closeToast}
          key={"1"}
          color={colorToast}
        />
      )}
    </>
  );
};

export default Login;
